export default __webpack_public_path__ + "static/media/assignmentsIcon.d5df0102.svg";